import React, { useState } from 'react';

export default function AboutPage() {
  const [formState, setFormState] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formState.name.trim() || !formState.email.trim() || !formState.message.trim()) return;
    setSubmitted(true);
    setFormState({ name: '', email: '', message: '' });
  };

  return (
    <div className="max-w-2xl mx-auto px-4 py-8 pb-24 md:pb-10">
      <h1 className="text-2xl font-bold mb-6 text-gray-800">About BoVi Price</h1>
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 mb-6">
        <p className="mb-6 text-gray-600 leading-relaxed">BoVi Price helps you compare supermarket prices, find the best deals, and save money on your groceries. Upload your receipts or search for products to get started!</p>
        <h2 className="text-lg font-semibold mb-3 text-gray-800">Frequently Asked Questions</h2>
        <div className="space-y-3">
          <div className="border-b border-gray-100 pb-3">
            <h3 className="font-medium text-gray-700 text-sm">How does BoVi Price work?</h3>
            <p className="text-sm text-gray-500 mt-1">Upload receipts or search for products to compare prices across supermarkets in your area.</p>
          </div>
          <div className="border-b border-gray-100 pb-3">
            <h3 className="font-medium text-gray-700 text-sm">Is it free to use?</h3>
            <p className="text-sm text-gray-500 mt-1">Yes, BoVi Price is completely free for users.</p>
          </div>
          <div>
            <h3 className="font-medium text-gray-700 text-sm">How accurate are the prices?</h3>
            <p className="text-sm text-gray-500 mt-1">Prices are extracted from real receipts and updated regularly by our community.</p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <h2 className="text-lg font-semibold mb-4 text-gray-800">Contact Us</h2>
        {submitted ? (
          <div className="text-center py-6">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-green-100 rounded-full mb-3">
              <svg className="w-6 h-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
            </div>
            <h3 className="font-semibold text-gray-700 mb-1">Message sent</h3>
            <p className="text-sm text-gray-500">Thanks for reaching out. We'll get back to you soon.</p>
            <button onClick={() => setSubmitted(false)} className="mt-4 text-sm text-red-800 hover:underline">Send another message</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col gap-3">
            <input 
              type="text" 
              placeholder="Your Name" 
              required
              value={formState.name}
              onChange={(e) => setFormState(s => ({ ...s, name: e.target.value }))}
              className="border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-red-700 focus:border-transparent" 
            />
            <input 
              type="email" 
              placeholder="Your Email" 
              required
              value={formState.email}
              onChange={(e) => setFormState(s => ({ ...s, email: e.target.value }))}
              className="border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-red-700 focus:border-transparent" 
            />
            <textarea 
              placeholder="Your Message" 
              required
              rows={4}
              value={formState.message}
              onChange={(e) => setFormState(s => ({ ...s, message: e.target.value }))}
              className="border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-red-700 focus:border-transparent resize-none" 
            />
            <button type="submit" className="bg-red-800 text-white px-4 py-2.5 rounded-lg hover:bg-red-900 transition text-sm font-medium">
              Send Message
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
